// ExportButton.jsx
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { getFormValues } from 'redux-form';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import MenuItem from '@material-ui/core/MenuItem';
import Tooltip from '@material-ui/core/Tooltip';
import ExportIcon from 'mdi-react/CloudDownloadIcon';

import DataExportCore from './DataExportCore'; // Import the new core component
import DataExportForm from './DataExportForm'; // Specific form for Data Export

// Removed: Col, Container, Row, Modal, ButtonToolbar, Button
// Removed: Fab, EmailOutlineIcon, ShareIcon, PhoneIcon, LocationIcon, InfoIcon, CloseIcon, HelpIcon, ContactIcon, LockIcon, AddListIcon
// Removed: ExpandMoreIcon, ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails
// Removed: SnackBar, Publisher, TrialSubscribe, StripeCardSetupModal
// Removed: subscriptionPlans, dataExportCreditMap, coreTranslate, calculateCredits, translateCreditToDollars, costPerCredit, maxDownload, DataCreditUsageProgress
// Removed: all utility and API helper imports (they are now in DataExportCore)
// Removed: withStyles (not used in ExportButton)

class ExportButton extends React.Component {
	static propTypes = {
		t: PropTypes.func.isRequired,
		user: PropTypes.object.isRequired,
		formValues: PropTypes.object, // From redux-form
		core_name: PropTypes.string,
		q: PropTypes.string,
		fq: PropTypes.string,
		fl: PropTypes.string,
		sort: PropTypes.string,
		title: PropTypes.string,
		description: PropTypes.string,
		export_name: PropTypes.string,
		custom_class: PropTypes.string,
		menu_button: PropTypes.node,
		parentSnackOpen: PropTypes.func, // Optional prop for external snackbar
		on_toggle: PropTypes.func, // Optional callback for toggle
	};

	renderButton = ({ onClick }) => {
		const { title, custom_class, menu_button, icon_only, t } = this.props;
		return (
			<Tooltip title={title ? title : t('Request Data Export')}>
				{menu_button ?
					<MenuItem onClick={onClick}>{menu_button}</MenuItem>
					: icon_only ?
					<IconButton
						onClick={onClick}
						className={custom_class ? custom_class : ''}
					>
						<ExportIcon size={24} />
					</IconButton>
					:
					<Button
						variant="outlined"
						color="inherit"
						size="small"
						onClick={onClick}
						className={custom_class ? custom_class : ''}
						startIcon={<ExportIcon size={16} />}
					>
						Export
					</Button>
				}
			</Tooltip>
		);
	};

	render() {
		const {
			user, core_name, q, fq, fl, sort, title, description,
			export_name, formValues, parentSnackOpen, on_toggle,
		} = this.props;

		// The formValues prop from Redux-Form is passed directly here.
		// DataExportCore will use this prop for its form operations.
		return (
			<DataExportCore
				user={user}
				core_name={core_name || "we3-properties"} // Default core_name if not provided
				q={q}
				fq={fq}
				fl={fl}
				sort={sort}
				title={title || 'Data Export'}
				description={description}
				ExportFormComponent={DataExportForm}
				defaultExportName={export_name || "My Data Export"} // Pass default export name
				exportType="data" // Specifies this is a general data export
				renderButton={this.renderButton}
				parentSnackOpen={parentSnackOpen}
				formValues={formValues} // Pass formValues from Redux-Form
				onToggle={on_toggle} // Pass the on_toggle callback
			/>
		);
	}
}

function mapStateToProps(state) {
	// Get form values for the specific form used by ExportButton (DataExportForm)
	return {
		user: state.user,
		formValues: getFormValues("export_form")(state), // Assuming DataExportForm uses "export_form"
	};
}

// Only connect to Redux for user and formValues
export default connect(mapStateToProps)(withTranslation('common')(ExportButton));

